import type { RouteLocationNormalizedLoaded } from 'vue-router';

export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.client) return;

  const redirectTo = calcRedirect(to);
  if (!redirectTo) return;

  const { $logger } = useNuxtApp();
  const log = $logger.withScope('↪️ redirect');

  log({ from: to.path, to: redirectTo });
  return navigateTo(redirectTo, { redirectCode: 301 });
});

function calcRedirect({ path, name }: RouteLocationNormalizedLoaded) {
  // на preview редирект мешает нормальной его работе
  if (name === 'preview') return;

  let redirect = path.toLowerCase();

  // обработка случая, когда вместо "?" поставили "&"
  if (redirect.includes('/&')) {
    redirect = redirect.replace('/&', '/?');
  }
  if (redirect.includes('&')) {
    redirect = redirect.replace('&', '/?');
  }

  // редирект для всех страниц со статьями с URL c датой на URL без даты
  const singleArticleWithDate = /\/\d{4}\/\d{1,2}\/\d{1,2}(\/.*)/g;
  if (redirect.match(singleArticleWithDate)) {
    redirect = redirect.replaceAll(singleArticleWithDate, '$1');
  }

  // убираем множественные "/"
  redirect = redirect.replaceAll(/\/{2,}/g, '/');

  // добавляем "/" в конец
  if (!redirect.endsWith('/') && !redirect.includes('?')) {
    redirect += '/';
  }

  if (redirect !== path) {
    return redirect;
  }
}
